import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './ProfessionalHealthPage.css';

const ProfessionalHealthPage: React.FC = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState('ePrescription');
  const [imageSrc, setImageSrc] = useState<string>('');
  
  const tabKeys = ['ePrescription', 'imagerie', 'biologie', 'rendezVous', 'teletravail'];
  
  useEffect(() => {
    const extensions = ['png', 'jpg', 'jpeg', 'webp'];
    let found = false;

    const tryLoadImage = () => {
      for (const ext of extensions) {
        const imagePath = `/images/${activeTab}.${ext}`;
        const img = new Image();
        
        img.onload = () => {
          setImageSrc(imagePath);
          found = true;
        };

        img.onerror = () => {
          if (!found) {
            // Continue to check the next extension
          }
        };

        img.src = imagePath;
        if (found) break;
      }
      
      // Fallback if no image found
      if (!found) {
        setImageSrc('/images/default.png');
      }
    };

    tryLoadImage();
  }, [activeTab]);

  return (
    <div className="professional-health-page">
      <nav className="service-nav">
        <div className="container">
          <ul className="nav-links">
            {tabKeys.map((key) => (
              <li key={key} >
                <button
                  className={`nav-link ${activeTab === key ? 'active' : ''} ` }
                  onClick={() => setActiveTab(key)}
                >
                  {t(`professionalHealth.${key}.title`)}
                </button>
              </li>
            ))}
          </ul>
        </div>
      </nav>

      <div className="service-content">
        <div className="container">
          <div className="service-card">
            <div className="service-image">
              <img src={imageSrc} alt={t(`professionalHealth.${activeTab}.title`)} />
            </div>
            <div className="service-description">
              <h2 >{t(`professionalHealth.${activeTab}.title`)}</h2>
              <pre className="service-text">{t(`professionalHealth.${activeTab}.description`)}</pre>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfessionalHealthPage;
